import * as yup from 'yup';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { AllTypeContexts } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_TEXT } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use PasswordType from application-types instead.
 */
export class PasswordType extends StringTypeBase {
  contexts = AllTypeContexts;

  group = TYPE_GROUP_TEXT;

  name = 'Password';

  friendlyName = 'Password';

  get example() {
    return 'Secret_password1!';
  }

  get default(): any {
    return '';
  }

  buildSchema() {
    return yup.string().nullable();
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Password from application-types instead.
 */
const definition = new PasswordType();

Types.addBaseType(definition);
export default definition;
